<template src="./user-profile.html">

</template>

<script>

import Vue from 'vue'
import ContextPage from '@/components/misc/context-page/ContextPage.vue'
import { EventBus } from '@/router/bus'
import { hasOrganizationManageClaim } from '@/router/auth'
import securityStore from '@/store/security-store'

export default {
  components: {
    ContextPage
  },
  data () {
    return {
      loading: false,
      loadingPersonalInformation: false,
      loadingPassword: false,
      loadingPersonalSettings: false,
      isUserWithoutAvailableRoles: false,
      userClaims: [],
      userRoles: [],
      help: {
        profile: Vue.$helpConfig.userProfile
      },
      user: {
        name: '',
        email: '',
        login: ''
      },
      password: {
        old: '',
        new: '',
        repeated: ''
      },
      newInformation: {
        name: '',
        email: '',
        login: '',
        id: 0
      },
      csvDelimiterOptions: Vue.$config.csv_delimiters,
      usernameRules: [
        v => !!(v && v.length !== 0 && v.trim()) || this.$t('validation.usernameRequired'),
        v => (v && v.length <= 32) || this.$t('validation.usernameTooLong')
      ],
      nameRules: [
        v => !!(v && v.length !== 0 && v.trim()) || this.$t('validation.nameRequired')
      ],
      emailRules: [
        v => !!(v && v.length !== 0 && v.trim()) || this.$t('validation.emailRequired'),
        v => /.+@.+\..+/.test(v) || this.$t('validation.emailRequired')
      ],
      oldPasswordRules: [
        v => !!(v && v.length !== 0 && v.trim()) || this.$t('validation.oldPasswordRequired')
      ],
      newPasswordRules: [
        v => (v && v.length !== 0 && v.trim() && v.trim().length >= 12) || this.$t('validation.password.0'),
        v => /[0-9]/.test(v) || this.$t('validation.password.1'),
        v => /[A-Z]/.test(v) || this.$t('validation.password.2'),
        v => /[!@#$%^&*()_+\-=[\]{};':"\\|,.<>/?]/.test(v) || this.$t('validation.password.3')
      ],
      repeatPasswordRules: [
        v => !!(v.trim()) || this.$t('validation.repeatMustMatch'),
        v => v === this.password.new || this.$t('validation.repeatMustMatch')
      ],
      isInformationFormValid: false,
      isPasswordFormValid: false
    }
  },
  computed: {
    infoFormBtnDisabled () {
      return !this.isInformationFormValid
    },
    passwordFormBtnDisabled () {
      return !this.isPasswordFormValid
    },
    canEditOrganization () {
      return this.user && hasOrganizationManageClaim()
    }
  },
  created () {
    this.$http.get(Vue.$apiConfig.userProfileInformationGet + '/' + securityStore.getters.username).then(
      response => {
        const data = response.data.payload
        this.user = this.shallowCopy(data)
        this.newInformation = this.shallowCopy(data)
      },
      error => {
        this.formatErrorResponse(error)
      }
    )
  },
  methods: {
    changeInfo () {
      this.loadingPersonalInformation = true
      if (this.$refs.formInformation.validate()) {
        this.$http.put(Vue.$apiConfig.updateUserProfilePut + '/' + this.user.login, this.newInformation).then(
          response => {
            const payload = response.data.payload
            EventBus.$emit('alert', {
              variant: 'success',
              message: this.$t('userAdministration.userInformationUpdateSuccess'),
              errors: []
            })
            this.user.name = payload.name
            this.user.email = payload.email
            this.loadingPersonalInformation = false
          },
          error => {
            this.formatErrorResponse(error)
            this.loadingPersonalInformation = false
          }
        )
      }
    },
    gotoRoleDescription () {
      this.$router.push('/administration/role/' + this.user.roleId)
    },
    gotoOrganization () {
      if (this.canEditOrganization) {
        this.$router.push('/administration/organization/' + this.user.organizationId)
      } else {
        this.$router.push('/registry/organization/' + this.user.organizationId)
      }
    },
    informationNotSet () {
      return (!this.newInformation.name || !this.newInformation.email || !this.newInformation.login)
    },
    changePassword () {
      this.loadingPassword = true
      if (this.$refs.formPassword.validate()) {
        const changePasswordApi = Vue.$apiConfig.userPasswordChangePut.replace('{login}', this.user.login)
        this.$http.put(changePasswordApi, {
          password: this.password.old,
          newPassword: this.password.new,
          login: this.user.login
        }).then(
          response => {
            Vue.use(response)
            EventBus.$emit('alert', {
              variant: 'success',
              message: this.$t('userAdministration.passwordChanged'),
              errors: []
            })
            this.loadingPassword = false
            this.$refs.formPassword.reset()
          },
          error => {
            this.formatErrorResponse(error)
            this.loadingPassword = false
          }
        )
      }
    },
    pushIfNotExists (array, newClaim) {
      for (const i in array) {
        const element = array[i]
        if (element.id === newClaim.roleId) {
          return element
        }
      }
      const newRole = {
        id: newClaim.roleId,
        description: newClaim.roleDescription,
        claims: [],
        userHasRole: true,
        userHasSomeClaims: false
      }
      array.push(newRole)
      return newRole
    }
  }
}
</script>

<style>

  .claimItem {
    font-size: 16px ;
    font-weight: 300 ;
    line-height: 1 ;
    letter-spacing: 0.02em ;
    font-family: 'Source Sans Pro', sans-serif ;
    margin-left: 30px ;
  }

  .role-popout {
    background-color: #E0F2F1 !important;
  }

</style>
